import type { ReactNode } from 'react'
import { cn } from '~/lib/utils'

export interface EmptyStateProps {
    title: string
    description?: string
    /** 보조 액션(버튼 등). */
    action?: ReactNode
    className?: string
}

/** 빈 상태 공통 컴포넌트. 로딩·빈·오류 상태는 공통으로 통일한다. */
export function EmptyState({
    title,
    description,
    action,
    className,
}: EmptyStateProps) {
    return (
        <div
            className={cn(
                'border-border flex flex-col items-center justify-center gap-3 rounded-md border border-dashed p-10 text-center',
                className
            )}>
            <p className='text-foreground text-base font-medium'>{title}</p>
            {description ? (
                <p className='text-muted-foreground max-w-sm text-sm'>
                    {description}
                </p>
            ) : null}
            {action}
        </div>
    )
}
